/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NextVisit/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function NextVisit({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Unscheduled/More/Content/AddAppointment/Content/NextVisit",
  onChange
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let addAppointmentIntervalToNextValueData = fromData.useDataValue({ viewPath,
context: 'add_appointment',
path: 'interval_to_next',
})
let addAppointmentIntervalToNextChangeData = fromData.useDataChange({ viewPath,
context: 'add_appointment',
path: 'interval_to_next',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let onBlur = fromHelpers.useOnChange({
  children,
  viewPath,
  onChange
  
})
let onSubmit = fromHelpers.useOnChange({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="options"
 from={optionsValueData}
 data="add_appointment.interval_to_next"
 value={addAppointmentIntervalToNextValueData}
 onChange={addAppointmentIntervalToNextChangeData}
 onBlur={onBlur}
 onSubmit={onSubmit}
 size="medium"
 clearFilterOnBlur={true}
 maxWidth={250}
 marginTop={24}
 marginLeft={dtSpaceM}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Next visit"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}